import './polyfills.js';
import './vendor/modernizr';
import './nav';
import './media';
import './news-single';
import './polaroid';
import './single-musician';
import './video-handler';
import './form';
import './footer';
import './vendor/slick';
import './testimonials';
